<template class="container">
  <div>

    <div style="display:flex; justify-content: center; padding: 2rem 4rem 0;">
      <v-text-field filled label="Size nasıl yardımcı olabilirim?" outlined append-icon="mdi-magnify"></v-text-field>
    </div>

    <div style="display: flex; justify-content: space-around;">
      <div class="faq-categories">
        <ul v-for="item in faqJSON">
          <li><a @click="changeJson(item.id)">{{ item.menuTitle }}</a></li>
        </ul>
      </div>

      <div style="flex: 0 70%;">
        <v-expansion-panels accordion>
          <v-expansion-panel v-for="item in faqQuestions" v-bind:key="item.id" class="accordion-item">
            <v-expansion-panel-header>{{ item.question }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ item.answer }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<style>

.v-expansion-panels--accordion {
  width: 100%;
  padding: 0rem 4rem;
  margin: auto;
}

.v-expansion-panel-header {
  color: inherit;
  position: relative;
  color: #2c3d4f;
  font-weight: bold;
  min-height: auto !important;
}

.v-expansion-panel-header:hover {
  background-color: #f6f6f6;
  transition: background-color 300ms ease-in-out;
}

.v-expansion-panel--active > .v-expansion-panel-header {
  background: #f6f6f6;
}

.active {
  background: #f6f6f6;
}

.v-expansion-panel-content__wrap {
  padding: 16px 24px;
  border: 1px solid #e6e6e6;
  border-top: none;
  font-weight: 300;
}


.faq-categories {
  padding: 0rem 4rem;
  flex: 0 1 30%;
}

.faq-categories ul {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  margin: 0;
  padding: 0;
}

.faq-categories ul li {
  position: relative;
  margin: 0;
  border-bottom: 1px solid #e6e6e6;
  list-style: none;
}

.faq-categories ul li a {
  color: #000;
  padding: 0.75rem 1rem;
  display: block;
  text-decoration: none;
}

.faq-categories ul li a:hover {
  background-color: #f1f1f1;
}

</style>

<script>
import FrequentlyAskedQuestions from "./mixins/FrequentlyAskedQuestions";

export default {
  mixins: [FrequentlyAskedQuestions]
};
</script>



// WEBPACK FOOTER //
// src/pages/faq/FrequentlyAskedQuestions.vue